import { useCallback, useMemo, useSyncExternalStore } from "react"
import { useAuth } from "@clerk/nextjs"

function readDevSessionCookie(): string | null {
  if (process.env.NODE_ENV !== "development") return null
  if (typeof document === "undefined") return null
  return document.cookie.match(/dev_session_token=([^;]+)/)?.[1] ?? null
}

function useDevSessionAuth() {
  const rawToken = useSyncExternalStore(subscribeToDevSession, readDevSessionCookie, serverDevSession)

  const claims = useMemo(() => {
    if (!rawToken) return null
    const payload = rawToken.split(".")[1]
    if (!payload) return null
    try {
      return JSON.parse(atob(payload)) as Record<string, unknown>
    } catch {
      return null
    }
  }, [rawToken])

  const getToken = useCallback(async () => rawToken, [rawToken])

  return { rawToken, claims, getToken }
}

const subscribeToDevSession = () => () => {}
const serverDevSession = () => null

export function useDevAuth() {
  const clerkAuth = useAuth()
  const { claims, getToken } = useDevSessionAuth()

  if (!claims) return clerkAuth

  return {
    ...clerkAuth,
    isLoaded: true,
    isSignedIn: true as const,
    userId: String(claims.user_id),
    sessionClaims: claims,
    getToken,
  }
}
